package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun CommandMetadata() {
    SpellMetadata(
        spellIndex = "command",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL),
        material = null,
        duration = "1 round",
        damageBase = null,
        damageScaling = null,
        savingThrow = "WIS (None)",
        aoe = null,
        concentration = false
    )
}
